import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { legalNav, siteConfig } from '@/constants/site'

/**
 * The reveal footer. The footer itself is fixed to the bottom of the screen; this window, as tall
 * as the footer, clips it to itself, so the page slides up and away to uncover it like a curtain.
 */
export const SiteFooter: FC = (): ReactNode => {
    return (
        <div className='relative z-0 h-[calc(74px+clamp(110px,17.5vw,265px))] [clip-path:inset(0)]'>
            <footer className='fixed inset-x-0 bottom-0 h-[calc(74px+clamp(110px,17.5vw,265px))] bg-background text-ink/55'>
                <nav aria-label='Legal' className='flex items-center justify-center gap-[clamp(20px,3vw,36px)] px-[clamp(20px,4vw,56px)] pb-[26px] pt-[22px] text-[13px] leading-none'>
                    <span>
                        © 2026 {siteConfig.name}
                    </span>
                    {legalNav.map(item => (
                        <Link key={item.href} href={item.href} className='transition-colors duration-200 hover:text-ink focus-visible:text-ink'>
                            {item.label}
                        </Link>
                    ))}
                </nav>

                <div className='mt-2 flex h-[clamp(110px,17.5vw,265px)] items-center justify-center overflow-hidden px-[clamp(12px,2vw,40px)] pb-4'>
                    <span
                        role='img'
                        aria-label={siteConfig.name}
                        className='select-none whitespace-nowrap font-serif text-[clamp(56px,12.5vw,190px)] leading-none tracking-[0.02em] text-press [text-shadow:0_1px_0_rgb(255_253_248/0.9),0_-1px_1px_rgb(40_38_34/0.3)]'
                    >
                        {siteConfig.name.toUpperCase()}
                    </span>
                </div>
            </footer>
        </div>
    )
}
